import { Spin } from 'antd';
import { useParams } from 'react-router';
import {
  FavePassProductDetails,
  useFetchMcProductDetails,
} from '../../../../services/MySubmissions';
import useSetBreadCrumbParams from '../../../../hooks/useSetBreadCrumbParams';
import { dateOrDash, valueOrDash } from '../../../../utils/utilFunctions';
import { PageHeaderWithBackButton } from '../../../../components/common';
import CardSection from '../../../../components/CardSection';
import { DisplayMarkdownOrDash } from '../../helpers';

const FavePassSubmissionsDetailsView = () => {
  const { id } = useParams();
  const favePassId = String(id);

  const { data: favepassSubmissionsData, isFetching } =
    useFetchMcProductDetails({
      id: favePassId,
    });

  const isNotEmpty = favepassSubmissionsData !== undefined;

  useSetBreadCrumbParams(
    [
      {
        label: `${String(
          favepassSubmissionsData?.company?.name,
        )} (Fave Pass Detail)`,
        key: String(id),
      },
    ],
    isNotEmpty,
  );

  const productDetails =
    favepassSubmissionsData?.product_details as FavePassProductDetails;

  const favePassDetailDescriptions = [
    {
      key: '1',
      label: 'Name',
      children: valueOrDash(productDetails?.name),
    },
    {
      key: '2',
      label: 'Description',
      children: valueOrDash(productDetails?.description),
    },
    {
      key: '3',
      label: 'Total Sessions',
      children: valueOrDash(productDetails?.total_sessions),
    },
    {
      key: '4',
      label: 'Bank Account',
      children: valueOrDash(productDetails?.finance_account_humanize),
    },
    {
      key: '5',
      label: 'Main Category',
      children: valueOrDash(productDetails?.main_category_humanize),
    },
    {
      key: '6',
      label: 'Image',
      children: (
        <div>
          {productDetails?.image_url ? (
            <div>
              <a
                href={productDetails.image_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {productDetails.image_url}
              </a>
              <img src={productDetails.image_url} alt="Fave Pass Image" />
            </div>
          ) : (
            valueOrDash(productDetails?.image_url)
          )}
        </div>
      ),
    },
  ];

  const pricingDescriptions = [
    {
      key: '1',
      label: 'Original Amount',
      children: valueOrDash(
        productDetails?.original_amount?.currency +
          productDetails?.original_amount?.amount,
      ),
    },
    {
      key: '2',
      label: 'Discounted Amount',
      children: valueOrDash(
        productDetails?.original_amount?.currency +
          productDetails?.discounted_amount?.amount,
      ),
    },
    {
      key: '3',
      label: 'Fave Fee (%)',
      children: valueOrDash((productDetails?.fee_percentage || 0) + '%'),
    },
    {
      key: '4',
      label: 'PayLater by Grab Fee (%)',
      children: valueOrDash(
        (productDetails?.grabpay_later_fee_percentage || 0) + '%',
      ),
    },
    {
      key: '5',
      label: 'Cap',
      children: valueOrDash(productDetails?.max_cap),
    },
    {
      key: '6',
      label: 'User Purchase Limit',
      children: valueOrDash(productDetails?.user_purchase_limit),
    },
  ];

  const redemptionDetails = [
    {
      key: '1',
      label: 'Start Date',
      children: dateOrDash(productDetails?.start_date),
    },
    {
      key: '2',
      label: 'End Date',
      children: dateOrDash(productDetails?.end_date),
    },
    {
      key: '3',
      label: 'Reservation Requirement Type',
      children: valueOrDash(
        productDetails?.reservation_requirement_type_humanize,
      ),
    },
    {
      key: '4',
      label: 'Validity',
      children: valueOrDash(productDetails?.validity),
    },
  ];

  const finePrintDescriptions = [
    {
      key: '1',
      label: 'What you get',
      children: <DisplayMarkdownOrDash text={productDetails?.what_you_get} />,
    },
    {
      key: '2',
      label: 'Cancellation Policy',
      children: (
        <DisplayMarkdownOrDash text={productDetails?.cancellation_policy} />
      ),
    },
    {
      key: '3',
      label: 'Fine Print',
      children: <DisplayMarkdownOrDash text={productDetails?.fine_print} />,
    },
  ];

  const outletDescriptions = [
    {
      key: '1',
      label: 'Apply to Outlets',
      children: (
        <div
          dangerouslySetInnerHTML={{
            __html: valueOrDash(productDetails?.outlets_humanize),
          }}
        />
      ),
    },
  ];

  const sections = [
    {
      key: '1',
      title: 'Fave Pass Details',
      data: favePassDetailDescriptions,
    },
    {
      key: '2',
      title: 'Pricing Details',
      data: pricingDescriptions,
    },
    {
      key: '3',
      title: 'Redemption Details',
      data: redemptionDetails,
    },
    {
      key: '4',
      title: 'Fine Print Details',
      data: finePrintDescriptions,
    },
    {
      key: '5',
      title: 'Outlet Details',
      data: outletDescriptions,
    },
  ];

  return (
    <div>
      <PageHeaderWithBackButton
        title={valueOrDash(favepassSubmissionsData?.company?.name)}
        subTitle={'Fave Pass Detail'}
      />
      <Spin spinning={isFetching} style={{ width: '100%' }}>
        {sections.map(({ key, ...restItems }) => (
          <CardSection key={key} sectionNumber={key} {...restItems} />
        ))}
      </Spin>
    </div>
  );
};

export default FavePassSubmissionsDetailsView;
